import {PartnerUiSettings} from "@bounce/shared/consumer/declarations";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = {partnerDomain?: string};

type Data = PartnerUiSettings;

export const getPartnerUiSettings = async (variables: Variables): Promise<Data> => {
  const result = await axiosConsumerAppInstance.get<Data, AxiosResponse<Data>>(`/partners/ui`);
  return result.data;
};

export const useGetPartnerUiSettings = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> =>
  useBaseQuery<Data, Variables>(["partner_ui", variables.partnerDomain], getPartnerUiSettings, variables, options);
